module.exports = __webpack_public_path__ + "teqbahn-assets/media/Blacktransparent.bbd91a2e.png";